export default __webpack_public_path__ + "static/media/882-1.00ae0816.jpg";